<div class="version-component">
  <div class="version-field">
    <p class="version-text">{{ 'SHARED.VERSION' | translate }} {{ version?.adminUIVersion }}</p>
  </div>
</div>
